module.exports = __webpack_public_path__ + "static/media/xavier.df096725.jpg";